// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2htmP","overflowing":"ReadFullNote_overflowing__260Ex"};